module.exports = __webpack_public_path__ + "orange.png?86b2abc71ddd65d758d900034005b9c4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/orange.png
// module id = 20
// module chunks = 0